export default {
  year: '',
  month: '',
  endDate: '',
  startDate: ''
};
